import { FC } from "react"
import logo from "/logo-transparent.png"
import { cn } from "@/lib/utils"
import { RefreshCircle } from "@solar-icons/react"

interface LoaderProps {
  className?: string
}

export const AppBootstrapLoader: FC<LoaderProps> = ({ className = "" }) => {
  return (
    <div
      className={cn(
        "flex min-h-screen w-full items-center justify-center bg-background",
        className
      )}
    >
      <div className="relative flex h-28 w-28 items-center justify-center">
        <img
          src={logo}
          alt="Loading"
          className="relative z-10 h-16 w-16 object-contain"
        />
        <div
          className="absolute inset-0 rounded-full border-[3px] border-primary/20 border-t-primary motion-safe:animate-spin"
          style={{ animationDuration: "0.85s", animationTimingFunction: "linear" }}
          aria-hidden
        />
      </div>
    </div>
  )
}

export const ContentAreaLoader: FC<LoaderProps> = ({ className = "" }) => {
  return (
    <div
      className={cn(
        "flex min-h-[50vh] w-full items-center justify-center",
        className
      )}
    >
      <RefreshCircle
        className="h-8 w-8 animate-spin text-primary"
        style={{ animationDuration: "0.85s", animationTimingFunction: "linear" }}
      />
    </div>
  )
}

/** @deprecated Use AppBootstrapLoader for full-screen bootstrap loading */
const Preloader = AppBootstrapLoader

export default Preloader
